module.exports = __webpack_public_path__ + "img/cc_2018CHS270030_03_1280_GBA.0acd821c.jpg";